import { SerializedData, Store } from "bernie-core";
import { action, observable } from "mobx";
import { Template, FlexBffTemplateResponse } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";

export class TemplateStore extends Store {
  @observable
  public template: Template;

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(bffResponse: FlexBffTemplateResponse) {
    if (bffResponse) {
      this.template = bffResponse.template;
    }
  }
}
